<template>
    <div class="modal fade show in" id="fellowModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <a href="#" class="close" @click.prevent="closeModal"><span aria-hidden="true">&times;</span></a>

            <div class="row">

              <div class="col-md-8">

                <h3 class="modal-title" style="margin-bottom:12px;">{{selectedFellow.FirstName }} {{ selectedFellow.LastName}}</h3>
                <h6 v-if="selectedFellow.Applications__r">{{selectedFellow.Applications__r.records[0].College_Institution__r.Name}}</h6>
                <h4 v-if="selectedFellow.Applications__r"><small>{{selectedFellow.Applications__r.records[0].Major__c}}</small></h4>

                  <template v-if="selectedFellow.Fellow_Years__r && selectedFellow.Fellow_Years__r.records.length">
                    <hr/>

                    <article v-for="year in recordsOrderedByYear">
                      <h4><small>{{ year.Website_Display_Year__c }} Summer Internship</small></h4>
                      <h2>{{ year.Internship__r.Organization_Name__c }}</h2>
                      <p>{{ year.Internship__r.Name }}<span v-if="year.Internship__r.International_City__c">, {{ year.Internship__r.International_City__c }}</span><span v-if="year.Internship__r.International_Country__c && year.Internship__r.International_Country__c != 'USA'">, {{ year.Internship__r.International_Country__c }}</span></p>
                    </article>

                  </template>
                  <template v-else>
                    <hr/>

                    <article>
                      <h4><small>Summer Internship</small></h4>
                      <h6>Details coming soon</h6>
                    </article>
                  </template>

              </div>

              <div v-if="fellowPhoto" class="col-md-4 hidden-sm hidden-xs">
                <div class="img-circle img-tj" v-html="fellowPhoto">
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

</template>

<script>
import axios from 'axios'

export default {
  props: ['selectedFellow'],
  data(){
    return{
      fellowPhoto: null
    }
  },

  computed: {
    recordsOrderedByYear() {

      if(this.selectedFellow.Fellow_Years__r.records) {

        const records = this.selectedFellow.Fellow_Years__r.records

        return records.sort(function(record1,record2) {
          if (record1.Website_Display_Year__c < record2.Website_Display_Year__c)
            return -1;
          if (record1.Website_Display_Year__c > record2.Website_Display_Year__c)
            return 1;
          return 0;
        });
      }

    }
  },

  async created() {
    const response = await axios.get("/actions/community/data/get-contact-photo-bg", {
        params: {
          contactId: this.selectedFellow.Id
        }
      })
    this.fellowPhoto = response.data
  },

  mounted() {
    console.log(this.selectedFellow)
  },

  methods: {
    closeModal() {
      this.$emit('close-modal');
    }
  }
}

</script>

<styles>
  #fellowModal {
    background-color: RGBA(239,238, 228, 0.8 );
    z-index: 9999;
  }
</styles>



// WEBPACK FOOTER //
// scripts/jk-modal.vue